module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[69]312.e2e5541.woff2";